import React from 'react';
import StockChart from 'Components/common/components/StockChart';
import { useSelector } from 'react-redux';
import { CompanyStockChart } from 'Types/CompaniesTypes';
import { selectChartLoading, selectCompanyStockCharts } from 'Selector/CompaniesSelector';
import { Col, Row } from 'antd';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { selectClusterStocksChart, selectClusterStocksChartLoading } from '../../../Selector/ClustersSelector';

type Props = {
  isCluster?: boolean
  clusterCompanyId?: number
}

const defaultProps = {
  isCluster: false,
  clusterCompanyId: 0,
}
const FinancialsStockCharts = function FinancialsStockCharts(props: Props) {
  const { isCluster, clusterCompanyId } = props;
  const clusterStocksData = useSelector(selectClusterStocksChart);
  const clusterStockDataLoading = useSelector(selectClusterStocksChartLoading)
  const stocksData: CompanyStockChart | null = isCluster ? clusterStocksData[clusterCompanyId ?? 0] : useSelector(selectCompanyStockCharts);
  const stocksDataLoading: boolean = isCluster ? clusterStockDataLoading[clusterCompanyId ?? 0] : useSelector(selectChartLoading);
  const chartsData = stocksData?.chartsData;

  const returnStockChart = (heading: string, defaultTab = 'annual') => (
    <Col span={12} xs={24} sm={24} md={12}>
      <StockChart
        height="322px"
        heightSm="222px"
        width="100%"
        showTabs={false}
        showSubHeading
        chartHeading={`${heading} Stock Price`}
        chartsData={chartsData}
        defaultTab={defaultTab}
        className="finacial-chart"
      />
    </Col>
  );

  return (
    <Row gutter={20} className="w-100 m-x-y-c-0">
      {
        !stocksDataLoading ? stocksData?.status.toLowerCase() !== 'private' && chartsData
          && (
            <>
              {returnStockChart('Annual')}
              {returnStockChart('Daily', 'daily')}
            </>
          )
          : (
            <>
              <Col span={12} xs={24} sm={24} md={12}>
                <SkeletonCustom height="222px" width="100%" />
              </Col>
              <Col span={12} xs={24} sm={24} md={12}>
                <SkeletonCustom height="222px" width="100%" />
              </Col>
            </>
          )
      }
    </Row>
  );
};

FinancialsStockCharts.defaultProps = defaultProps;
export default FinancialsStockCharts;
